/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Enable_MidiInputs */

const en_options_adr_enable_midi = /** @type {(inputs: Options_Adr_Enable_MidiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable MIDI Control`)
};

const fr_options_adr_enable_midi = /** @type {(inputs: Options_Adr_Enable_MidiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer le contrôle MIDI`)
};

const de_options_adr_enable_midi = /** @type {(inputs: Options_Adr_Enable_MidiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIDI-Steuerung aktivieren`)
};

const it_options_adr_enable_midi = /** @type {(inputs: Options_Adr_Enable_MidiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita controllo MIDI`)
};

const ru_options_adr_enable_midi = /** @type {(inputs: Options_Adr_Enable_MidiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить управление MIDI`)
};

const es_options_adr_enable_midi = /** @type {(inputs: Options_Adr_Enable_MidiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar control MIDI`)
};

const zh_cn2_options_adr_enable_midi = /** @type {(inputs: Options_Adr_Enable_MidiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用 MIDI 控制`)
};

const ja_options_adr_enable_midi = /** @type {(inputs: Options_Adr_Enable_MidiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIDIコントロールを有効にする`)
};

const hi_options_adr_enable_midi = /** @type {(inputs: Options_Adr_Enable_MidiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIDI नियंत्रण सक्षम करें`)
};

const pt_pt2_options_adr_enable_midi = /** @type {(inputs: Options_Adr_Enable_MidiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar controle MIDI`)
};

/**
* | output |
* | --- |
* | "Enable MIDI Control" |
*
* @param {Options_Adr_Enable_MidiInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_enable_midi = /** @type {((inputs?: Options_Adr_Enable_MidiInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Enable_MidiInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_adr_enable_midi(inputs)
	if (locale === "de") return de_options_adr_enable_midi(inputs)
	if (locale === "it") return it_options_adr_enable_midi(inputs)
	if (locale === "ru") return ru_options_adr_enable_midi(inputs)
	if (locale === "es") return es_options_adr_enable_midi(inputs)
	if (locale === "zh-CN") return zh_cn2_options_adr_enable_midi(inputs)
	if (locale === "ja") return ja_options_adr_enable_midi(inputs)
	if (locale === "hi") return hi_options_adr_enable_midi(inputs)
	if (locale === "pt-PT") return pt_pt2_options_adr_enable_midi(inputs)
	return en_options_adr_enable_midi(inputs)
});